<template>
  <symbol>
    <!-- NOTE: 体感温度の色のグラフィック 34度〜14度 -->
    <!-- 34度 -->
    <radialGradient id="setstar-color-1">
      <stop
        offset="0%"
        stop-color="#e029c0"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#e029c0"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#e029c0"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 33度 -->
    <radialGradient id="setstar-color-2">
      <stop
        offset="0%"
        stop-color="#e02690"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#e02690"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#e02690"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 32度 -->
    <radialGradient id="setstar-color-3">
      <stop
        offset="0%"
        stop-color="#e02360"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#e02360"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#e02360"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 31度 -->
    <radialGradient id="setstar-color-4">
      <stop
        offset="0%"
        stop-color="#ec2430"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#ec2430"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#ec2430"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 30度 -->
    <radialGradient id="setstar-color-5">
      <stop
        offset="0%"
        stop-color="#f82500"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#f82500"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#f82500"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 29度 -->
    <radialGradient id="setstar-color-6">
      <stop
        offset="0%"
        stop-color="#f96300"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#f96300"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#f96300"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 28度 -->
    <radialGradient id="setstar-color-7">
      <stop
        offset="0%"
        stop-color="#faa000"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#faa000"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#faa000"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 27度 -->
    <radialGradient id="setstar-color-8">
      <stop
        offset="0%"
        stop-color="#fccf00"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#fccf00"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#fccf00"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 26度 -->
    <radialGradient id="setstar-color-9">
      <stop
        offset="0%"
        stop-color="#fdfe00"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#fdfe00"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#fdfe00"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 25度 -->
    <radialGradient id="setstar-color-10">
      <stop
        offset="0%"
        stop-color="#9efd00"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#9efd00"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#9efd00"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 24度 -->
    <radialGradient id="setstar-color-11">
      <stop
        offset="0%"
        stop-color="#3efb00"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#3efb00"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#3efb00"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 23度 -->
    <radialGradient id="setstar-color-12">
      <stop
        offset="0%"
        stop-color="#40fc50"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#40fc50"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#40fc50"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 22度 -->
    <radialGradient id="setstar-color-13">
      <stop
        offset="0%"
        stop-color="#41fc9f"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#41fc9f"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#41fc9f"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 21度 -->
    <radialGradient id="setstar-color-14">
      <stop
        offset="0%"
        stop-color="#44fdcf"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#44fdcf"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#44fdcf"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 20度 -->
    <radialGradient id="setstar-color-15">
      <stop
        offset="0%"
        stop-color="#46fdff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#46fdff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#46fdff"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 19度 -->
    <radialGradient id="setstar-color-16">
      <stop
        offset="0%"
        stop-color="#38c1ff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#38c1ff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#38c1ff"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 18度 -->
    <radialGradient id="setstar-color-17">
      <stop
        offset="0%"
        stop-color="#2a84ff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#2a84ff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#2a84ff"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 17度 -->
    <radialGradient id="setstar-color-18">
      <stop
        offset="0%"
        stop-color="#276bff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#276bff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#276bff"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 16度 -->
    <radialGradient id="setstar-color-19">
      <stop
        offset="0%"
        stop-color="#2352ff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#2352ff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#2352ff"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 15度 -->
    <radialGradient id="setstar-color-20">
      <stop
        offset="0%"
        stop-color="#2039ff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#2039ff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#2039ff"
        stop-opacity="0"
      />
    </radialGradient>

    <!-- 14度 -->
    <radialGradient id="setstar-color-21">
      <stop
        offset="0%"
        stop-color="#1c20ff"
        stop-opacity="1.0"
      />
      <stop
        offset="80%"
        stop-color="#1c20ff"
        stop-opacity="0.7"
      />
      <stop
        offset="100%"
        stop-color="#1c20ff"
        stop-opacity="0"
      />
    </radialGradient>

  </symbol>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// setstar.vue?1b76a688